<template>
  <div class="group-manage conmon-top micro-page">
    <el-container :style="'minHeight:'+ (height1-260) + 'px'">
      <!--左侧分组-->
      <el-aside class="left-aside-type"
                width="220px"
                :style="'minHeight:'+ (height1-260) + 'px'"
                style="margin-top: 24px;margin-left: 20px;">

        <div class="group-search group-search_1">
          <div style="display: flex;justify-content: space-between;
            align-items: center;height: 30px;padding-top: 5px;border-bottom: 1px solid #e5e5e5;
            padding-bottom: 0px;margin-bottom: 0px">
            <div><span style="padding-left: 15px">看板</span></div>
            <div><i @click="handleBoardItem('add', '')"
                 v-if="butsObj.add"
                 style="font-size: 20px;cursor: pointer;color: #1890FF;margin-right: 15px"
                 class="el-icon-circle-plus-outline"
                 title="添加看板"></i></div>
            <!--                <div-->
            <!--                        class="add-group-btn"-->
            <!--                        @click="handleBoardItem('add', '')"-->
            <!--                >-->
            <!--                    -->
            <!--                </div>-->
          </div>
          <div>
            <el-input placeholder="请输入内容"
                      v-model.trim="groupName"
                      style="width: 189px;"
                      @keyup.enter.native="searchQrcodeType">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"
                 style="color: #333;cursor: pointer;font-weight: bold"
                 @click="searchQrcodeType"></i>
            </el-input>
          </div>
        </div>
        <el-menu :default-active="elMenuIndex"
                 class="el-menu-vertical-demo"
                 style="max-height: 850px;width:100%; border-right: none; overflow-y: auto;overflow-x:hidden;margin-bottom: 0;padding-bottom: 0"
                 @open="handleOpen"
                 @close="handleClose"
                 text-color="#333"
                 active-text-color="#333">
          <el-menu-item :class="item.choosen ? 'getIt' : ''"
                        :index="index + ''"
                        v-for="(item, index) in tableData"
                        :key="index">
            <div class="menu-btn"
                 v-if="item.name !== '全部'">
              <i @click="handleBoardItem('edit', item)"
                 v-if="butsObj.edit"
                 class="el-icon-edit"
                 style="margin-right: 0"></i>
              <i @click="deleteBoardAction(item.id)"
                 v-if="butsObj.del"
                 class="el-icon-close"
                 style="margin-right: 0"></i>
            </div>
            <span class="menu-title"
                  :title="item.name"
                  @click="chooseTagsType(index, item)">{{ item.name }}</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <!--右侧列表-->
      <div style="padding:0;width: calc(100% - 220px)">
        <div class="base-input ovf-hd"
             style="margin-bottom: 14px!important;margin: 24px 24px 14px 24px!important;">
          <el-row class="search-title">
            <el-col :span="24"
                    class="text-align-right board-title">
              <div></div>
              <div class="">
                <div @click="addSingleChartAction"
                     v-if="butsObj.select_dan">
                  <img src="../../assets/images/card-ticket/board_1.png" /><span>选择单图</span>
                </div>
                <div @click="confirmSingleAction"
                     v-if="butsObj.add_dan">
                  <img src="../../assets/images/card-ticket/board_2.png" /><span>添加单图</span>
                </div>
                <div @click="saveAnotherBoardDialog = true"
                     v-if="butsObj.save_as">
                  <img src="../../assets/images/card-ticket/board_3.png" /><span>另存看板</span>
                </div>
                <div @click="saveDashBoardAction(1)"
                     v-if="butsObj.save">
                  <img src="../../assets/images/card-ticket/board_4.png" /><span>保存看板</span>
                </div>
                <div @click="openBig">
                  <img src="../../assets/images/card-ticket/board_all.png" /><span>全屏</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="boardContent">
          <el-row v-if="layout.length==0">
            <div class="board_blank"
                 @click="confirmSingleAction">
              <div>
                <div><i class="el-icon-circle-plus-outline"
                     title="添加单图"></i></div>
                <div>
                  <span>添加单图</span>
                </div>
              </div>
            </div>
          </el-row>
          <el-row v-if="layout.length!=0"
                  class="search-title common-table-top"
                  style="padding-right:0;height:100%;min-height: 300px;display: flex;
            justify-content: left;
            background-color: #f0f2f5;">
            <!--拖拽-->
            <div class="middle"
                 style="width: 100%;margin: 0;">
              <div id="middle"
                   style="margin-left: -10px;margin-right: -10px">
                <grid-layout :layout="layout"
                             :auto-size="true"
                             :col-num="20"
                             :row-height="50"
                             :max-rows="100"
                             :is-draggable="true"
                             :is-resizable="true"
                             :vertical-compact="true"
                             :is-mirrored="false"
                             :margin="[10, 10]"
                             :use-css-transforms="true"
                             @layout-updated="layoutUpdatedEvent">
                  <grid-item v-for="item in layout"
                             :key="item.i"
                             :min-w="6"
                             :min-h="6"
                             :x="item.x"
                             :y="item.y"
                             :w="item.w"
                             :h="item.h"
                             :i="item.i"
                             :heightFromChildren="true"
                             @resize="resizeEvent"
                             @move="moveEvent"
                             @resized="resizedEvent"
                             @moved="movedEvent"
                             style="border: 1px solid #E8E8E8;background-color: #fff;"
                             class="item-contentTest"
                             v-loading="loading">
                    <template v-for="(one, key) in chartObject">
                      <!--                                v-loading="loading"-->
                      <div @mouseover="changeActive($event)"
                           @mouseout="removeActive($event)"
                           class="item-content"
                           :class="'item-content'+ one.figureId"
                           v-if="item.i === one.figureId"
                           :key="key"
                           style="display: flex; justify-content: flex-start; flex-direction: column; position: relative;height: 100%; width: 100%;">
                        <el-row style="height: 45px;position: relative">
                          <div class="chart-title">{{ one.figureName }}</div>
                          <div class="button-content"
                               style="position: absolute;top: 0px;right: 5px;cursor: pointer">
                            <i class="iconfont icon-icon-test10 analyse-icon"
                               @click="deleteSingleChart(one)">
                            </i>
                            <i class="iconfont icon-icon-test9 analyse-icon"
                               @click="pushToPage(item)">
                            </i>
                            <el-dropdown>
                              <span class="el-dropdown-link">
                                <i class="el-icon-more"
                                   style="margin-left: 5px;"></i>
                              </span>
                              <el-dropdown-menu slot="dropdown"
                                                style="margin-top: 0px">
                                <!--表格-->
                                <el-dropdown-item @click.native="chooseTable('table', item, one)"
                                                  :disabled="one.hasTable === 0 ? true : false">
                                  <i :class="(item.showType === '' ? (one.defaultShow === 'table') : (item.showType === 'table')) ? 'icon-blue' : 'icon-black'"
                                     class="analyse-res-icon iconfont icon-wenbenjieguo-1">
                                  </i>
                                </el-dropdown-item>
                                <!--饼-->
                                <el-dropdown-item @click.native="choosePie('pieChart', item, one)"
                                                  :disabled="one.hasPieChart === 0 ? true : false">
                                  <i :class="(item.showType === '' ? (one.defaultShow === 'pieChart') : (item.showType === 'pieChart')) ? 'icon-blue' : 'icon-black'"
                                     class="analyse-res-icon icon-bingzhuangtu-1 iconfont">
                                  </i>
                                </el-dropdown-item>
                                <!--线-->
                                <el-dropdown-item @click.native="chooseLine('lineChart', item, one)"
                                                  :disabled="one.hasLineChart === 0 ? true : false">
                                  <i :class="(item.showType === '' ? (one.defaultShow === 'lineChart') : (item.showType === 'lineChart')) ? 'icon-blue' : 'icon-black'"
                                     class="analyse-res-icon icon-zhexiantu- iconfont">
                                  </i>
                                </el-dropdown-item>
                                <!--柱-->
                                <el-dropdown-item @click.native="chooseZhu('barGraph', item, one)"
                                                  :disabled="one.hasBarGraph === 0 ? true : false">
                                  <i :class="(item.showType === '' ? (one.defaultShow === 'barGraph') : (item.showType === 'barGraph')) ? 'icon-blue' : 'icon-black'"
                                     class="iconfont icon-zhuzhuangjieguo-1 analyse-res-icon">
                                  </i>
                                </el-dropdown-item>
                                <!--数字-->
                                <el-dropdown-item @click.native="chooseNum('singleMetric', item, one)"
                                                  :disabled="one.hasSingleMetric === 0 ? true : false">
                                  <i class="iconfont icon-shuzijieguo-1 analyse-res-icon"
                                     :class="(item.showType === '' ? (one.defaultShow === 'singleMetric') : (item.showType === 'singleMetric')) ? 'icon-blue' : 'icon-black'">
                                  </i>
                                </el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </div>
                        </el-row>
                        <div v-show="(one.hasTable === 1 && item.showType === 'table') || (one.hasTable === 1 && item.showType === '' && one.defaultShow === 'table')"
                             class="table-div"
                             :ref="'table' + one.figureId"
                             :id="'table' + one.figureId">
                          <el-table :data="one.tableData.showTableObj"
                                    width="100%">
                            <el-table-column v-for="(it, ind) in one.tableData.columns"
                                             :key="ind"
                                             :label="it.title">
                              <template slot-scope="scope">
                                {{scope.row[it.dataIndex]}}
                              </template>
                            </el-table-column>
                          </el-table>
                          <div class="pagetion"
                               v-if="one.tableData.total!=1 && one.tableData.total!=0">
                            <span @click="changePage(0, one)"
                                  class="pagetion_1 el-icon-caret-left"
                                  :class="pageTable===1?'nojian':''"></span>
                            <span class="pagetion_2">{{pageTable}}/{{one.tableData.total}}</span>
                            <span @click="changePage(1, one)"
                                  class="pagetion_1 el-icon-caret-right"
                                  :class="pageTable===one.tableData.total?'nojian':''"></span>
                          </div>
                          <!--                                        <a-locale-provider :locale="zhCN">-->
                          <!--                                            <a-table-->
                          <!--                                                    class="board-table"-->
                          <!--                                                    :pagination="{-->
                          <!--                          total: one.tableData.total || 0,-->
                          <!--                          defaultCurrent: page,-->
                          <!--                          pageSize: 6,-->
                          <!--                          size: 'small',-->
                          <!--                          hideOnSinglePage: true,-->
                          <!--                          showQuickJumper: false,-->
                          <!--                          showSizeChanger: false,-->
                          <!--                          showTotal: function (total) { // 设置显示一共几条数据-->
                          <!--                            return '共 ' + total + ' 条'-->
                          <!--                          }-->
                          <!--                        }"-->
                          <!--                                                    :columns="one.tableData.columns"-->
                          <!--                                                    :dataSource="one.tableData.tableData">-->
                          <!--                                            </a-table>-->
                          <!--                                        </a-locale-provider>-->
                        </div>
                        <!--饼图-->
                        <div class="chart-content1"
                             v-show="one.hasPieChart === 1 && item.showType === 'pieChart'|| (one.hasPieChart === 1 && item.showType === '' && one.defaultShow === 'pieChart')"
                             :ref="'pieContent' + one.figureId">
                          <div :ref="'chartPie' + one.figureId"
                               :id="'pieChart' + one.figureId"
                               style="padding-bottom: 10px;border: 1px solid #fff">
                          </div>

                        </div>
                        <!--柱状图-->
                        <div class="chart-content1"
                             v-show="(one.hasBarGraph === 1 && item.showType === 'barGraph') || (one.hasBarGraph === 1 && item.showType === '' && one.defaultShow === 'barGraph')"
                             :ref="'barContent' + one.figureId">
                          <div :ref="'barChart' + one.figureId"
                               :id="'barGraph' + one.figureId"
                               style="padding-bottom: 10px">
                          </div>
                        </div>
                        <div class="chart-content1"
                             v-show="(one.hasSingleMetric === 1 && item.showType === 'singleMetric')
                                         || (one.hasSingleMetric === 1 && item.showType === '' && one.defaultShow === 'singleMetric')"
                             :ref="'singleMetric' + one.figureId">
                          <!--数字-->
                          <div class="singleNum">
                            <div class="singleNum_2"
                                 :id="'singleMetric' + one.figureId">{{one.singleMetric}}</div>
                          </div>
                        </div>
                        <!--折线图-->
                        <div class="chart-content1"
                             v-show="(one.hasLineChart === 1 && item.showType === 'lineChart')  || (one.hasLineChart === 1 && item.showType === '' && one.defaultShow === 'lineChart')"
                             :ref="'lineContent' + one.figureId">
                          <div :ref="'chartLine' + one.figureId"
                               :id="'lineChart' + one.figureId"
                               style="padding-bottom: 10px">

                          </div>
                        </div>
                        <!-- 右小角 拖拽-->
                        <div class="fixIcone">
                          <img src='../../assets/images/icn_2.png'>
                          <!--                                        <span class="el-icon-rank"></span>-->
                        </div>

                      </div>
                    </template>
                  </grid-item>
                </grid-layout>
              </div>
            </div>
          </el-row>
        </div>
      </div>
    </el-container>
    <!--      全屏-->
    <div v-if="allBigDialog"
         class="allBigDialog">
      <div class="allBig"
           :style="'height:'+ height +'px'">
        <div class="allBig_title">
          <div class="allBig_title2">
            <span>{{boardName}}</span>
          </div>
          <div @click="allBigDialog = false"
               class="allBig_title1">
            <img style="width: 20px;padding-right: 5px"
                 src="../../assets/images/card-ticket/board_all.png" />
            <span style="line-height: 30px">退出全屏</span>
          </div>
        </div>
        <div class="allBig_content"
             id="allBig_content">
          <BigLayout :dataArr="dataArr"
                     :objArr="objArr"
                     @addSingleChartAction="addSingleChartAction"></BigLayout>
          <!--                  <div v-for="(item, index) in figuresArray" :key="index" >-->
          <!--                      <div  v-if="item.showType !== 'table'" :id="'containe'+ item.id" style="height: 400px;overflow: hidden">-->

          <!--                      </div>-->
          <!--                      <div v-if="item.showType === 'table'" class="table-div"-->
          <!--                           :id="'containe'+ item.id" style="overflow-x: hidden;overflow-y: scroll;height: 400px">-->
          <!--                          <a-locale-provider :locale="zhCN">-->
          <!--                              <a-table-->
          <!--                                      class="board-table"-->
          <!--                                      :pagination="{-->
          <!--                          total: chartObject[item.id].tableData.total || 0,-->
          <!--                          defaultCurrent: page,-->
          <!--                          pageSize: 6,-->
          <!--                          size: 'small',-->
          <!--                          hideOnSinglePage: true,-->
          <!--                          showQuickJumper: false,-->
          <!--                          showSizeChanger: false,-->
          <!--                          showTotal: function (total) { // 设置显示一共几条数据-->
          <!--                            return '共 ' + total + ' 条'-->
          <!--                          }-->
          <!--                        }"-->
          <!--                                      :columns="chartObject[item.id].tableData.columns"-->
          <!--                                      :dataSource="chartObject[item.id].tableData.tableData">-->
          <!--                              </a-table>-->
          <!--                          </a-locale-provider>-->
          <!--                      </div>-->

          <!--                  </div>-->
        </div>
      </div>
    </div>
    <!--  另存看板  -->
    <el-dialog title="另存看板"
               :visible.sync="saveAnotherBoardDialog"
               width="520px"
               class="cellDialog">
      <el-form :model="saveAnotherBoardForm"
               label-width="110px"
               ref="saveAnotherBoardForm"
               :rules="rulesSave">
        <el-form-item label="看板名称"
                      prop="name">
          <el-input v-model="saveAnotherBoardForm.name"
                    placeholder="请输入看板名称(20字以内)"
                    maxlength="20"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button class="dialog-cancel-btn"
                   style="margin-right: 20px"
                   @click="saveAnotherBoardDialog = false">取 消</el-button>
        <el-button class="dialog-confirm-btn"
                   type="primary"
                   style="margin-right: 20px"
                   @click="submitSaveAnotherBoardForm('saveAnotherBoardForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!--添加看板弹窗-->
    <el-dialog class="cellDialog base-dialog"
               title="新建看板"
               :visible.sync="addTagGroupDialog"
               width="520px">
      <el-form ref="addBoardForm"
               :model="addBoardData"
               :rules="rules">
        <el-form-item label="看板名称:"
                      :label-width="addLabelWidth"
                      prop="name">
          <el-input :maxlength="20"
                    type="text"
                    v-model.trim="addBoardData.name"
                    auto-complete="off"
                    placeholder="输入看板名称(20字以内)"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="margin-top: 10px">
        <el-button class="dialog-cancel-btn"
                   @click="addTagGroupDialog = false"
                   style="margin-left: 20px">取 消</el-button>
        <el-button :disabled="btnDisabled"
                   class="dialog-confirm-btn"
                   type="primary"
                   @click="submitEditBoard('add')">确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑看板窗-->
    <el-dialog class="cellDialog base-dialog"
               title="编辑看板"
               :visible.sync="editTagsGroupDialog"
               width="520px">
      <el-form :rules="rules"
               ref="editBoardForm"
               :model="editBoardData">
        <el-form-item label="看板名称:"
                      :label-width="addLabelWidth"
                      prop="name">
          <el-input :maxlength="20"
                    type="text"
                    v-model.trim="editBoardData.name"
                    auto-complete="off"
                    placeholder="输入看板名称(20字以内)"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="margin-top: 10px">
        <el-button class="dialog-cancel-btn"
                   @click="editTagsGroupDialog = false"
                   style="margin-left: 20px">取 消</el-button>
        <el-button :disabled="btnDisabled"
                   class="dialog-confirm-btn"
                   type="primary"
                   @click="submitEditBoard('edit')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Table, LocaleProvider } from 'ant-design-vue'
import {
  getDashBoardList,
  addDashBoard,
  deleteDashboard,
  saveAnotherDashBoard,
  modifyDashBoardTitle,
  getSingleChartDashBoard,
  deleteSingleChartFromeDashBoard,
  updateDashBoard,
  getSingleChartDetails, butonsList, getMenId
} from '@/api/analyse.js'
import VueGridLayout from 'vue-grid-layout'
import BigLayout from './components/boardChart'
Vue.use(VueGridLayout)
var GridLayout = VueGridLayout.GridLayout
var GridItem = VueGridLayout.GridItem
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import TemplateMessage from '../weixin-manage/template-message'
export default {
  name: 'board-statistics',
  data () {
    var checkBoardName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('看板不能为空'))
      } else if (value.length > 20) {
        return callback(new Error('看板最多20个字符'))
      } else {
        callback()
      }
    }
    return {
      elMenuIndex: '0',
      pageTable: 1,
      dataArr: [],
      objArr: {},
      ischange: true,
      boardName: '',
      height: window.innerHeight,
      height1: window.screen.availHeight,
      allBigDialog: false,
      zhuw: 0,
      zhuh: 0,
      total: 0,
      zhCN,
      isDraggable: true,
      isDraggable1: false,
      formInlineTmp: {},
      formInline: {
        createUserName: '',
        name: '',
        limit: 10000000,
        page: 1
      }, // 查询看板数据
      addBoardData: {
        name: ''
      }, //新建看板数据
      editBoardData: {
        id: '',
        name: ''
      }, // 编辑看板数据
      isSwitchClick: 1, // 判断防止多次点击
      totalCount: 0,
      tableData: [], //看板列表
      groupName: '', // 搜索name
      layoutArr: [], // 渲染数据
      // figuresArray: [], // 拖拽列表数据
      // chartObject: [],
      count: 3, // 一行显示几个数据
      widthCount: 6, // 每一个的宽度和高度
      // layout: 6,
      changeResize: {
        w: 6,
        h: 6,
        index: 0
      },
      dashBoardId: '', // 当前选中看板id
      saveAnotherBoardForm: {},
      saveAnotherBoardDialog: false,
      addTagGroupDialog: false,
      editTagsDialog: false,
      modelData: [],
      changeGroupId: '',
      btnDisabled: false,
      editTagsGroupDialog: false,
      loading: false,
      limit: 10,
      addTagsForm: {
        name: ''
      },
      addLabelWidth: '80px',
      page: 1,
      hide: true,
      // 校验新建看板
      rulesSave: {
        name: [{ required: true, message: '请输入看板名称', trigger: 'blur' }]
      },
      rules: {
        name: [{ required: true, validator: checkBoardName, trigger: 'blur' }]
      },
      layout1: [],
      // 拖拽
      layout: [],
      newX: 0,
      newY: 0,
      saleXUnit: '',
      itemW: 10,
      itemH: 10,
      figuresArray: [],
      chartObject: {}, // 单图
      myChartPie: [],
      myChartLine: [],
      myChartZhu: [],
      xNames: [],
      yNames: [],
      xNamePie: '',
      chartDataY: [],
      chartDataX: [],
      chartDataYPie: [],
      addChart: false,
      barWidth: 0,
      butsObj: { // button按钮列表
        add: false, // 添加
        edit: false,
        del: false,
        save: false, // 保存看板
        save_as: false, // 另存看板
        select_dan: false, // 选择单图
        add_dan: false // 添加单图
      },
      boardScale: 80, // 获取右边宽度与里边可以拖动div比例确定里边图的大小
      screenHeight: window.innerWidth, // 屏幕宽度
    }
  },
  computed: {
    Newitems () {
      let _this = this
      let Newitems = []
      if (_this.groupName === '') {
        return
      }
      _this.tableData.map(function (item) {
        if (item.name.search(_this.groupName) != -1) {
          Newitems.push(item)
        }
      })
      return Newitems
    }
  },
  components: {
    TemplateMessage,
    BigLayout,
    GridLayout,
    GridItem,
    ATable: Table,
    ALocaleProvider: LocaleProvider
  },
  methods: {
    changePage (type, one) {
      if (type == 0) {
        if (this.pageTable > 1) {
          let start = (this.pageTable - 2) * 10
          let end = (this.pageTable - 1) * 10
          this.pageTable = this.pageTable - 1
          let newObj = this.getArrCont(start, end, one.tableData.tableData)
          this.chartObject[one.figureId].tableData.showTableObj = newObj
        }

      } else {
        let start = this.pageTable * 10
        let end = (this.pageTable + 1) * 10
        if (this.pageTable < one.tableData.total) {
          this.pageTable = this.pageTable + 1
          let newObj = this.getArrCont(start, end, one.tableData.tableData)
          this.chartObject[one.figureId].tableData.showTableObj = newObj
        }


      }
    },
    // 鼠标移入加入class
    changeActive ($event) {
    },
    removeActive ($event) {
    },
    // 渲染G
    openBig () {
      this.allBigDialog = true
      this.dataArr = this.figuresArray
      this.objArr = this.chartObject
    },
    // 全屏渲染
    renderChart1 () {

    },
    // 删除单图
    deleteSingleChart (item) {
      this.$alert('确认删除该单图?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        callback: action => {
          if (action == "confirm") {
            deleteSingleChartFromeDashBoard(this.dashBoardId, item.figureId).then(res => {
              if (res.data.code === 0) {
                this.getListData()
                let newfiguresArray = []
                this.figuresArray.map(function (it, ind) {
                  if (it.id !== item.figureId) {
                    newfiguresArray.push(it)
                  }
                })
                this.layout = []
                this.figuresArray = newfiguresArray
                let layoutArr = []
                let layoutArr1 = []
                for (var j = 0; j < newfiguresArray.length; j++) {
                  if (newfiguresArray[j].position !== '') {
                    let arr = JSON.parse(newfiguresArray[j].position)
                    let type = newfiguresArray[j].showType
                    layoutArr.push({
                      'x': arr[0],
                      'y': arr[1],
                      'w': arr[2],
                      'h': arr[3],
                      'i': JSON.parse(newfiguresArray[j].id),
                      'showType': type,
                      'type': newfiguresArray[j].type,
                      'name': newfiguresArray[j].name
                    })
                    layoutArr1.push({
                      'x': 10,
                      'y': 6,
                      'w': 10,
                      'h': 6,
                      'i': JSON.parse(newfiguresArray[j].id),
                      'showType': type,
                      'type': newfiguresArray[j].type,
                      'name': newfiguresArray[j].name
                    })
                  } else {
                    layoutArr1.push({
                      'x': 10,
                      'y': 6,
                      'w': 10,
                      'h': 6,
                      'i': JSON.parse(newfiguresArray[j].id),
                      'showType': type,
                      'type': newfiguresArray[j].type,
                      'name': newfiguresArray[j].name
                    })
                    layoutArr.push({
                      'x': 0,
                      'y': 0,
                      'w': 6,
                      'h': 9,
                      'i': JSON.parse(newfiguresArray[j].id),
                      'showType': '',
                      'type': newfiguresArray[j].type,
                      'name': newfiguresArray[j].name
                    })
                  }
                }
                this.layout1 = layoutArr1
                this.layout = layoutArr
                this.getSingleChartData()
                _g.toastMsg('success', res.data.des)
              } else {
                _g.toastMsg('error', res.data.des)
              }
            }).catch((error) => {
            })
          } else {

          }
        }
      })
    },
    pushToPage (item) {
      getSingleChartDetails(item.i).then(res => {
        window.localStorage.setItem('itemLayout', JSON.stringify(this.layout))
        let arr = Object.assign([], this.figuresArray)
        arr.map(function (item, index) {
          if (item.chartPie != undefined) {
            delete item.chartPie
          }
        })
        window.localStorage.setItem('itemFigures', JSON.stringify(arr))
        sessionStorage.setItem('queryJson', res.data.result.filterJson)
        window.localStorage.setItem('borderDetailsIsAdd', 'true')
        if (item.type === 1) {
          router.push({ path: '/home/customer-analyse', query: { id: item.i, name: res.data.result.name, isAdd: 1 } })
        }
        if (item.type === 2) {
          router.push({ path: '/home/behavior-analyse', query: { id: item.i, name: res.data.result.name, isAdd: 1 } })
        }
      }).catch((error) => {
      })
    },
    deleteDashboardAction (itemId) {
      this.$confirm('确定从当前看板移除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        deleteSingleChartFromeDashBoard(this.dashBoardId, itemId).then(res => {
          if (res.data.code === 0) {
            _g.toastMsg('success', '删除成功')
          } else {
            _g.toastMsg('error', res.data.des)
          }
          // this.getData()
        }).catch((err) => {
        })
      }).catch((error) => {
      })
    },
    submitSaveAnotherBoardForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveDashBoard()
        } else {
          return false
        }
      })
    },
    // 删除单图
    deleteOneWay (item) {
      this.$alert('确认删除该单图?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        callback: action => {
          if (action == 'confirm') {
            deleteSingleChartFromeDashBoard(this.dashBoardId, item.id).then(
              res => {
                if (res.data.code === 0) {
                  this.getListData()
                  let newfiguresArray = []
                  this.figuresArray.map(function (it, ind) {
                    if (it.id !== item.id) {
                      newfiguresArray.push(it)
                    }
                  })
                  this.figuresArray = newfiguresArray
                  // this.renderChart()
                  _g.toastMsg('success', res.data.des)
                } else {
                  _g.toastMsg('error', res.data.des)
                }
              }
            ).catch((err) => {
            })
          } else {
          }
        }
      })
    },
    // 另存看板
    saveDashBoard () {
      saveAnotherDashBoard(
        this.dashBoardId,
        this.saveAnotherBoardForm.name
      ).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '另存看板成功')
          this.saveAnotherBoardDialog = false
          this.getListData()
          // router.push({ path: '/home/board-list' })
        } else {
          _g.toastMsg('error', res.data.des)
        }
      }).catch((err) => {
      })
    },
    // 获取看板列表
    getListData (type) {
      let that = this
      this.loading = true
      getDashBoardList(
        this.formInline.page,
        this.formInline.limit,
        this.formInline.name,
        this.formInline.createUserName
      ).then(res => {
        if (res.data.code === 0) {
          // res.data.data.data.unshift({ id: '', name: '全部' })
          for (let item of res.data.data.data) {
            item.choosen = false
          }
          this.totalCount = res.data.data.total
          this.tableData = res.data.data.data
          let dashBoardId = window.localStorage.getItem('dashBoardId') || ''
          let index = 0
          res.data.data.data.map(function (it, ind) {
            if (it.id == dashBoardId) {
              index = ind
              that.elMenuIndex = ind.toString()
            }
          })
          if (type == 1) {
            this.boardName = this.tableData[index].name || ''
            this.dashBoardId = this.tableData[index].id || ''
            this.pushToDashBoardPage(this.tableData[index])
          }
        } else {
          _g.toastMsg('error', res.data.des)
        }
      }).catch((err) => {
      })
      this.openLoading()
    },
    // 添加看板列表
    addBoardAction () {
      addDashBoard(this.addBoardData.name).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.des)
          this.dialogVisible = false
          this.getListData('1')
        } else {
          _g.toastMsg('error', res.data.des)
        }
      }).catch((err) => {
      })
    },
    // 编辑看板
    editBoardAction () {
      if (this.isSwitchClick === 1) {
        this.isSwitchClick = 0
        this.$nextTick(() => {
          modifyDashBoardTitle(
            this.editBoardData.id,
            this.editBoardData.name
          ).then(res => {
            if (res.data.code === 0) {
              _g.toastMsg('success', res.data.des)
            } else {
              _g.toastMsg('error', res.data.error)
            }
            this.isSwitchClick = 1
            this.getListData()
          }).catch((err) => {
          })
        })
      }
    },
    // 删除看板
    deleteBoardAction (itemId) {
      this.$alert('确认删除该看板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        type: 'warning',
        callback: action => {
          if (action == "confirm") {
            deleteDashboard(itemId).then(res => {
              if (res.data.code === 0) {
                _g.toastMsg('success', res.data.des)
              } else {
                _g.toastMsg('error', res.data.des)
              }
              this.getListData('1')
            })
          }
        }
      })
    },
    // 添加或者编辑
    handleBoardItem (type, item) {
      if (type === 'add') {
        this.addBoardData.name = ''
        this.addTagGroupDialog = true
      } else {
        this.editBoardData = {
          id: item.id,
          name: item.name
        }
        this.editTagsGroupDialog = true
      }
    },
    // 添加编辑弹框确定
    submitEditBoard (type) {
      if (type === 'add') {
        // 添加看板
        this.$refs['addBoardForm'].validate(valid => {
          if (valid) {
            this.addTagGroupDialog = false
            this.addBoardAction()
          }
        })
      } else {
        // 编辑看板
        this.$refs['editBoardForm'].validate(valid => {
          if (valid) {
            this.editTagsGroupDialog = false
            this.editBoardAction()
          }
        })
      }
    },
    // 搜索看板
    searchQrcodeType () {
      for (let i in this.tableData) {
        this.tableData[i].choosen = false
        for (let j in this.Newitems) {
          if (this.tableData[i].id === this.Newitems[j].id) {
            this.tableData[i].choosen = true
          }
        }
      }
    },
    // 选择不同看板
    chooseTagsType (index, item) {
      if (this.ischange) {
        this.loading = true
        this.boardName = item.name
        this.changeGroupId = item.id
        window.localStorage.setItem('dashBoardId', item.id)
        this.page = 1
        this.pushToDashBoardPage(item)
      }

      // this.loadTagList()
    },
    // 左侧分组导航
    handleOpen (key, keyPath) {
    },
    handleClose (key, keyPath) {
    },
    // 选择看板，整理右侧数据
    pushToDashBoardPage (item) {
      let that = this
      let layoutArr = []
      this.loading = true
      this.chartObject = {}
      this.dashBoardId = item.id
      let index = []
      let maxy = 0
      for (var j = 0; j < item.figures.length; j++) {
        item.figures[j].chartPie = ''
        if (item.figures[j].position !== '') {
          let arr = JSON.parse(item.figures[j].position)
          let type = item.figures[j].showType
          if (arr[1] > maxy) {
            maxy = arr[1]
          }
          layoutArr.push({
            'x': arr[0],
            'y': arr[1],
            'w': arr[2],
            'h': arr[3],
            'i': JSON.parse(item.figures[j].id),
            'showType': type,
            'type': item.figures[j].type,
            'name': item.figures[j].name
          })
        } else {
          index.push(j)

          layoutArr.push({
            'x': 0,
            'y': 0,
            'w': 6,
            'h': 6,
            'i': JSON.parse(item.figures[j].id),
            'showType': '',
            'type': item.figures[j].type,
            'name': item.figures[j].name
          })
        }
      }
      if (index.length != 0) {
        index.map(function (it, ind) {
          layoutArr[it].y = maxy + 6
          maxy = maxy + 1
          let array = [layoutArr[it].x, layoutArr[it].y, layoutArr[it].w, layoutArr[it].h]
          item.figures[it].position = JSON.stringify(array)
        })
      }
      this.figuresArray = item.figures
      this.layout = layoutArr
      this.getSingleChartData()
    },
    // 切换渲染方式
    // 切换饼图
    choosePie (type, item, one, index) {
      let that = this
      // item.showType = type
      let className = one.idName
      let index1 = -1
      document.getElementById(className).style.display = 'none'
      this.figuresArray.map(function (i, ind) {
        if (i.id === item.i) {
          that.figuresArray[ind].showType = type
          that.layout[ind].showType = type
          index1 = ind
        }
      })
      this.chartObject[item.i].defaultShow = type
      let className1 = type + item.i

      document.getElementById(className1).style.display = 'block'
      let data = one.barLinePieData.valueList
      this.chartPieWay(className1, data, one, index1)
      this.saveDashBoardAction()
    },
    // 切换折线图
    chooseLine (type, item, one, index) {
      let that = this
      let className = one.idName
      document.getElementById(className).style.display = 'none'
      let id1 = 'pieChart' + item.i
      document.getElementById(id1).style.display = 'none'
      this.figuresArray.map(function (i, ind) {
        if (i.id === item.i) {
          that.figuresArray[ind].showType = type
          that.layout[ind].showType = type
        }
      })
      this.chartObject[item.i].defaultShow = type
      let className1 = type + item.i
      document.getElementById(className1).style.display = 'block'
      let data = one.barLinePieData.valueList
      this.chartLineWay(className1, data, one)
      this.saveDashBoardAction()
    },
    chooseZhu (type, item, one, index) {
      let that = this
      let className = one.idName
      document.getElementById(className).style.display = 'none'
      this.figuresArray.map(function (i, ind) {
        if (i.id === item.i) {
          that.figuresArray[ind].showType = type
          that.layout[ind].showType = type
        }
      })
      this.chartObject[item.i].defaultShow = type
      let className1 = type + item.i

      document.getElementById(className1).style.display = 'block'
      let data = one.barLinePieData.valueList
      one.widthPX = this.zhuw
      one.heightPX = this.zhuh
      this.chartBarGraphWay(className1, data, one)
      this.saveDashBoardAction()
    },
    chooseNum (type, item, one) {
      item.showType = type
      one.defaultShow = type
      this.saveDashBoardAction()
    },
    // 切换表格
    chooseTable (type, item, one, index) {
      //计算表格总条数，每页显示数据，当前页
      let tableObj = this.chartObject[one.figureId]
      let total = Math.ceil(one.tableData.tableData.length / 10)
      tableObj.tableData.total = total
      let showTableObj = this.getArrCont(0, 10, tableObj.tableData.tableData)
      tableObj.tableData.showTableObj = showTableObj
      item.showType = type
    },
    // 渲染折线图
    renderChart () {
      let that = this
      this.$nextTick(() => {
        this.figuresArray.map(function (item, index) {
          let id = 'containe' + item.id

          let dataObj = that.chartObject[item.id]
          dataObj.widthPX = (window.innerWidth / 2) - 20
          dataObj.heightPX = window.innerHeight / 2
          // if(item.showType === '') {item.showType = item.dataArr.defaultShow}
          if (item.showType === 'lineChart') {
            // 折线图
            let data = dataObj.barLinePieData.valueList
            that.chartLineWay(id, data, dataObj)
          } else if (item.showType === 'pieChart') {
            // 饼状图
            let data = dataObj.barLinePieData.valueList
            that.chartPieWay(id, data, dataObj)
          } else if (item.showType === 'table') {
            // 表格
          } else if (item.showType === 'barGraph') {
            // 柱状图
            let data = dataObj.barLinePieData.valueList
            that.chartBarGraphWay(id, data, dataObj)
          } else if (item.showType === 'singleMetric') {
            // 数字

          }
        })
      })
    },
    // 拖拽方法
    resizeEvent: function (i, newH, newW) {
      for (let it = 0; it < this.figuresArray.length; it++) {
        if (this.figuresArray[it].id === i) {
          let array = []
          let posArr = []
          if (this.figuresArray[it].position.length !== 0) {
            let obj = this.figuresArray[it].position
            if (typeof obj == 'object' && obj.constructor === Array) {
              posArr = this.figuresArray[it].position
            } else {
              posArr = JSON.parse(this.figuresArray[it].position)
            }
            array = [posArr[0], posArr[1], newW, newH]
          } else {
            array = [0, 0, newW, newH]
          }
          this.figuresArray[it].position = JSON.stringify(array)
        }
      }
      this.saveDashBoardAction()
    },
    resizeDiv (i, W, H, type) {
      // this.w = W
      // this.h = H
      this.boardScale = window.innerWidth / 20
      let barId = 'barChart' + i
      let barContentId = 'barContent' + i
      let barchart = this.$refs[barId]
      let barContent = this.$refs[barContentId]
      let bar
      if (barchart) {
        barchart[0].style.width = (W * this.boardScale) * 12 / 20 + 'px'
        barContent[0].style.width = (W * this.boardScale) * 13 / 20 + 'px'
        barchart[0].style.height = (H * this.boardScale) * 10 / 20 + 'px'
        barContent[0].style.height = (H * this.boardScale) * 13 / 20 + 'px'
      }

      let pieId = 'chartPie' + i
      let pieContentId = 'pieContent' + i
      let piechart = this.$refs[pieId]
      let pieContent = this.$refs[pieContentId]
      let pie
      if (piechart) {
        piechart[0].style.width = (W * this.boardScale) * 13 / 20 + 'px'
        pieContent[0].style.width = (W * this.boardScale) * 13 / 20 + 'px'
        // pie = this.$echarts.init(piechart[0])
        // pie.resize()
        piechart[0].style.height = (((H * this.boardScale) * 13 / 20) - 85) + 'px'
        pieContent[0].style.height = (((H * this.boardScale) * 16 / 20) - 85) + 'px'
      }

      let lineId = 'chartLine' + i
      let lineContentId = 'lineContent' + i
      let linechart = this.$refs[lineId]
      let lineContent = this.$refs[lineContentId]
      let line
      if (linechart) {
        linechart[0].style.width = (W * this.boardScale) * 14 / 20 + 'px'
        lineContent[0].style.width = (W * this.boardScale) * 14 / 20 + 'px'
        // line = this.$echarts.init(linechart[0])
        linechart[0].style.height = (H * this.boardScale) * 10 / 20 + 'px'
        lineContent[0].style.height = (H * this.boardScale) * 15 / 20 + 'px'
        // line.resize()
      }

      let metricId = 'singleMetric' + i
      let singleMetric = this.$refs[metricId]
      if (singleMetric) {
        singleMetric[0].style.width = (W * this.boardScale) * 15 / 20 + 'px'
        singleMetric[0].style.height = (H * this.boardScale) * 15 / 20 + 'px'
      }
    },
    moveEvent: function (i, newX, newY, e) {

    },
    movedEvent: function (i, newX, newY, e) {
      for (let its = 0; its < this.figuresArray.length; its++) {
        if (this.figuresArray[its].id === i) {
          let array = []
          let posArr = []
          if (this.figuresArray[its].position.length !== 0) {
            let obj = this.figuresArray[its].position
            if (typeof obj == 'object' && obj.constructor === Array) {
              posArr = this.figuresArray[its].position
            } else {
              posArr = JSON.parse(this.figuresArray[its].position)
            }
            array = [newX, newY, posArr[2], posArr[3]]
          } else {
            array = [newX, newY, 6, 4]
          }
          this.figuresArray[its].position = JSON.stringify(array)
        }
      }
      this.saveDashBoardAction()
    },
    // 默认加载宽高计算
    defalutResizedEvent (i, W, H, type, index) {
      this.boardScale = window.innerWidth / 20
      // 饼图
      let pieId = 'chartPie' + i
      let piechart = this.$refs[pieId]
      if (piechart) {
        let width = (parseInt(piechart[0].parentNode.parentNode.parentNode.style.width) - 20)
        let height = (parseInt(piechart[0].parentNode.parentNode.parentNode.style.height) - 80)
        piechart[0].style.width = width + 'px'
        piechart[0].style.height = height + 'px'
        this.chartObject[i].widthPXP = width
        this.chartObject[i].heightPXP = height
      }
      // 折线图
      let lineId = 'chartLine' + i
      let linechart = this.$refs[lineId]
      if (linechart) {
        let width = (parseInt(linechart[0].parentNode.parentNode.parentNode.style.width) - 60)
        let height = (parseInt(linechart[0].parentNode.parentNode.parentNode.style.height) - 60)
        linechart[0].style.width = width + 'px'
        linechart[0].style.height = height + 'px'
        this.chartObject[i].widthPXL = width
        this.chartObject[i].heightPXL = height
      }
      // 柱状图
      let barId = 'barChart' + i
      let barchart = this.$refs[barId]
      if (barchart) {
        let width = (parseInt(barchart[0].parentNode.parentNode.parentNode.style.width) - 60)
        let height = (parseInt(barchart[0].parentNode.parentNode.parentNode.style.height) - 60)
        barchart[0].style.width = width + 'px'
        barchart[0].style.height = height + 'px'
        this.chartObject[i].widthPXB = width
        this.chartObject[i].heightPXB = height
      }

      // 数字
      let metricId = 'singleMetric' + i
      let singleMetric = this.$refs[metricId]
      if (singleMetric) {
        let width = (parseInt(singleMetric[0].parentNode.parentNode.style.width) - 60)
        let height = (parseInt(singleMetric[0].parentNode.parentNode.style.height) - 60)
        singleMetric[0].style.width = width + 'px'
        singleMetric[0].style.height = height + 'px'
        this.chartObject[i].widthPX = width
        this.chartObject[i].heightPX = height
      }
      // table
      let chatData = this.chartObject[i]
      if (type === 'pieChart') {
        this.chartPieWay("pieChart" + i, chatData.barLinePieData.valueList, chatData, index)
      } else if (type === 'lineChart') {
        this.chartLineWay("lineChart" + i, chatData.barLinePieData.valueList, chatData)
      } else if (type === 'barGraph') {
        this.chartBarGraphWay("barGraph" + i, chatData.barLinePieData.valueList, chatData)
      } else if (type === 'table') {
        let barId = 'table' + i
        let tablechart = this.$refs[barId]
        if (tablechart) {
          let width = (parseInt(tablechart[0].parentNode.parentNode.style.width) - 60)
          let height = (parseInt(tablechart[0].parentNode.parentNode.style.height) - 60)
          this.chartObject[i].widthPX = width
          this.chartObject[i].heightPX = height
          this.chartObject[i].widthPXB = width
          this.chartObject[i].heightPXB = height
          this.chartObject[i].widthPXL = width
          this.chartObject[i].heightPXL = height
        }
      }
    },
    // 拖拽宽高计算
    resizedEvent: function (i, newH, newW, newHPx, newWPx) {
      //饼图
      let pieId = 'chartPie' + i
      let piechart = this.$refs[pieId]
      if (piechart) {
        if (newWPx > 500) {
          piechart[0].style.width = (newWPx - 60) + 'px'
          this.chartObject[i].widthPXP = newWPx - 60
        } else {
          piechart[0].style.width = (newWPx) + 'px'
          this.chartObject[i].widthPXP = newWPx
        }
        piechart[0].style.height = (newHPx - 60) + 'px'
        this.chartObject[i].heightPXP = newHPx - 60

      }
      // 折线图
      let lineId = 'chartLine' + i
      let linechart = this.$refs[lineId]
      if (linechart) {
        linechart[0].style.width = (newWPx - 60) + 'px'
        linechart[0].style.height = (newHPx - 60) + 'px'
        this.chartObject[i].widthPXL = newWPx - 60
        this.chartObject[i].heightPXL = newHPx - 60

      }
      // 柱状图
      let barId = 'barChart' + i
      let barchart = this.$refs[barId]
      if (barchart) {
        barchart[0].style.width = (newWPx - 60) + 'px'
        barchart[0].style.height = (newHPx - 60) + 'px'
        this.chartObject[i].widthPXB = newWPx - 60
        this.chartObject[i].heightPXB = newHPx - 60
      }
      // 数字
      let metricId = 'singleMetric' + i
      let singleMetric = this.$refs[metricId]
      if (singleMetric) {
        singleMetric[0].style.width = newWPx - 60 + 'px'
        singleMetric[0].style.height = (newHPx - 60) + 'px'
        this.chartObject[i].widthPX = newWPx - 60
        this.chartObject[i].heightPX = newHPx - 60
      }

      let chatData = this.chartObject[i]
      let type = ''
      let index = -1
      this.figuresArray.map(function (it, ind) {
        if (it.id === i) {
          type = it.showType
          index = ind
        }
      })
      if (type === '') { type = this.chartObject[i].defaultShow }
      if (type == 'pieChart') {
        this.chartPieWay("pieChart" + i, chatData.barLinePieData.valueList, chatData, index)
      } else if (type === 'lineChart') {
        this.chartLineWay("lineChart" + i, chatData.barLinePieData.valueList, chatData)
      } else if (type === 'barGraph') {
        this.chartBarGraphWay("barGraph" + i, chatData.barLinePieData.valueList, chatData)
      }

    },

    toDecimal2NoZero (num) {
      let x = ("" + num).replace(/^\d+\./, '').length
      if (x > 2) {
        num = num.toFixed(2)
      }
      return num
    },
    // 渲染饼图的方法(new)
    chartPieWay (id, data, item, index) {
      let all = 0
      data.map(function (ite, ind) {
        ite.y = parseFloat(ite.y)
        all = parseFloat(ite.y) + all
      })
      data.map(function (ite, ind) {
        ite.percent = (parseFloat(ite.y) / all).toFixed(4)
      })
      if (this.figuresArray[index].chartPie === undefined || this.figuresArray[index].chartPie === 'undefined' || this.figuresArray[index].chartPie == '') {
        const chart = new G2.Chart({
          container: id,
          autoFit: false,
          width: item.widthPXP,
          height: item.heightPXP,
        });
        chart.data(data);
        chart.coordinate('theta', {
          radius: 0.75,
        });
        chart.tooltip({
          showTitle: false,
          showMarkers: false,
          itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}：{value}</li>',
        });
        chart.animate(true)
        // 辅助文本
        const interval = chart
          .interval()
          .adjust('stack')
          .position('y')
          .color('x', ['#1890FF', '#13C2C2', '#2FC25B', '#FACC14', '#F04864', '#8EE5B4'])
          .tooltip('x*percent*y', (x, percent, y) => {
            percent = y + ' ( ' + this.toDecimal2NoZero(percent * 100) + '%)'
            return {
              name: x,
              value: percent,
            };
          });

        chart.interaction('element')
        chart.render()
        this.figuresArray[index].chartPie = chart
      }
      else {
        if (this.figuresArray[index].chartPie) {
          this.figuresArray[index].chartPie.changeSize(item.widthPXP, item.heightPXP)
          // if(item.widthPXP > 400) {
          //   this.figuresArray[index].chartPie.legend(true)
          // } else {
          //   this.figuresArray[index].chartPie.legend(true)
          // }
          this.figuresArray[index].chartPie.render(true)
        }
      }
    },
    // 渲染折线图fangfa(new)
    chartLineWay (id, data, item) {
      document.getElementById(id).innerHTML = ''
      // 面积图
      const chart = new G2.Chart({
        container: id,
        autoFit: true,
        width: item.widthPXL,
        height: item.heightPXL - 10,
        padding: 'auto'
      });

      chart.data(data);
      chart.scale({
        y: {
          min: 0,
        },
        x: {
          range: [0, 1]
        },
      });
      chart.tooltip({
        showCrosshairs: false,
        shared: true,
        showTitle: true,
        title: 'x',
        showMarkers: false,
        itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" ' +
          'class="g2-tooltip-marker"></span>{value2}<span class="g2-tooltip-value"></span></li>',
      });
      chart.axis('y', {
        line: {
          stroke: '#808080',
          lineWidth: 1,
          strokeOpacity: 0.1
        },
        position: 'left',
        title: {
          autoRotate: true, // 是否需要自动旋转，默认为 true
          offset: 0, // 数值，设置坐标轴标题距离坐标轴线的距离
          // 设置标题的文本样式
          textStyle: {
            textAlign: 'center', // 文本对齐方向，可取值为： start middle end
            fill: '#404040', // 文本的颜色
            fontSize: '12', // 文本大小
            fontWeight: 'bold', // 文本粗细
            rotate: 90, // 文本旋转角度，以角度为单位，仅当 autoRotate 为 false 时生效
            textBaseline: 'top' // 文本基准线，可取 top middle bottom，默认为middle
          },
          text: item.barLinePieData.yName,
          position: 'top'
        }
      })

      chart.axis('x', {
        label: {
          formatter: (val) => {
            return val
          },
          offsetY: 20,
          autoRotate: false,
        },
        title: {
          autoRotate: false, // 是否需要自动旋转，默认为 true
          offset: 0, // 数值，设置坐标轴标题距离坐标轴线的距离
          // 设置标题的文本样式
          textStyle: {
            textAlign: 'center', // 文本对齐方向，可取值为： start middle end
            fill: '#404040', // 文本的颜色
            fontSize: '12', // 文本大小
            fontWeight: 'bold', // 文本粗细
            rotate: 30, // 文本旋转角度，以角度为单位，仅当 autoRotate 为 false 时生效
            textBaseline: 'top' // 文本基准线，可取 top middle bottom，默认为middle
          },
          text: item.barLinePieData.xName,
          position: 'center'
        }
      });
      chart.area().position('x*y').color('#1890FF').tooltip('x*y', (x, y) => {
        y = item.barLinePieData.yName + '：' + y
        return {
          name: x,
          value2: y,
        }
      })
      chart.line().position('x*y').color('#1890FF').tooltip('x*y', (x, y) => {
        y = item.barLinePieData.yName + '：' + y
        return {
          name: x,
          value2: y,
        }
      })

      chart.render();
    },
    chartBarGraphWay (id, data, item) {
      let size = 20
      if (item.widthPXB < 300) {
        size = 15
      }
      document.getElementById(id).innerHTML = ''
      if (data.length > 6) {
        const columnPlot = new G2Plot.Column(document.getElementById(id), {
          title: {
            visible: false,
            text: '',
          },
          description: {
            visible: false,
            text: '',
          },
          width: item.widthPXB,
          height: item.heightPXB,
          adjustPosition: true,
          forceFit: true,
          data,
          padding: 'auto',
          meta: {
            x: {
              alias: item.barLinePieData.xName,
            },
            y: {
              alias: item.barLinePieData.yName,
            }
          },
          xField: "x",
          xAxis: {
            line: {
              visible: true
            },
            visible: true,
            label: {
              autoHide: true,
              autoRotate: false,
            },
          },
          yAxis: {
            visible: true,
            label: {
              visible: true,
              formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
            },
          },
          yField: "y",
        });
        columnPlot.render()
      } else {
        let data1 = []
        data.map(function (ite, ind) {
          data1.push({
            type: ite.x,
            value: ite.y
          })
        })
        const chart = new G2.Chart({
          container: id,
          autoFit: true,
          width: item.widthPXB,
          height: item.heightPXB,
          padding: 'auto',
        });
        chart.data(data1);
        chart.scale('value', {
          alias: item.barLinePieData.yName,
          nice: false,
        });

        chart.axis('type', {
          tickLine: {
            alignTick: false,
          },
        });
        chart.axis('value', {
          label: {
            formatter: (val) => {
              return val
            },
          },
        })
        chart.axis('value', {
          position: 'left',
          title: {
            autoRotate: true, // 是否需要自动旋转，默认为 true
            offset: 0, // 数值，设置坐标轴标题距离坐标轴线的距离
            // 设置标题的文本样式
            textStyle: {
              textAlign: 'center', // 文本对齐方向，可取值为： start middle end
              fill: '#404040', // 文本的颜色
              fontSize: '12', // 文本大小
              fontWeight: 'bold', // 文本粗细
              rotate: 90, // 文本旋转角度，以角度为单位，仅当 autoRotate 为 false 时生效
              textBaseline: 'top' // 文本基准线，可取 top middle bottom，默认为middle
            },
            text: item.barLinePieData.yName,
            position: 'top'
          }
        })
        chart.axis('type', {
          label: {
            formatter: (val) => {
              return val
            },
            offsetY: 20,
            autoRotate: false,
          },
          title: {
            autoRotate: false, // 是否需要自动旋转，默认为 true
            offset: 0, // 数值，设置坐标轴标题距离坐标轴线的距离
            // 设置标题的文本样式
            textStyle: {
              textAlign: 'center', // 文本对齐方向，可取值为： start middle end
              fill: '#404040', // 文本的颜色
              fontSize: '12', // 文本大小
              fontWeight: 'bold', // 文本粗细
              rotate: 30, // 文本旋转角度，以角度为单位，仅当 autoRotate 为 false 时生效
              textBaseline: 'top' // 文本基准线，可取 top middle bottom，默认为middle
            },
            text: item.barLinePieData.xName,
            position: 'center'
          }
        });
        chart.legend(false)
        chart.tooltip({
          showTitle: true,
          title: 'type',
          showMarkers: false,
          itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" ' +
            'class="g2-tooltip-marker"></span>{value1}<span class="g2-tooltip-value"></span></li>',
        });
        chart.interval().position('type*value').size(size).color('type', (val) => {
          return '#1980FF'
        }).tooltip('type*value', (type, value) => {
          value = item.barLinePieData.yName + '：' + value
          return {
            value1: value,
          }
        })
          .label('value', {
            content: (originData) => {
              const val = parseFloat(originData.value)
              if (val < 0.05) {
                return (val * 100).toFixed(1)
              }
            },
            offset: 12,
          });
        chart.render();
      }
    },
    // 跳转选择单图页面
    confirmSingleAction () {
      window.localStorage.setItem('dashBoardId', this.dashBoardId)
      // if (this.selectType === 1) {
      let arr = Object.assign([], this.figuresArray)
      arr.map(function (item, index) {
        if (item.chartPie != undefined) {
          delete item.chartPie
        }
      })
      window.localStorage.setItem(
        'itemLayout',
        JSON.stringify(arr)
      )
      window.localStorage.setItem(
        'itemFigures',
        JSON.stringify(arr)
      )
      window.localStorage.setItem('borderDetailsIsAdd', 'true')
      router.push({ path: '/home/customer-analyse' })
    },
    // 添加单图
    addSingleChartAction () {
      let arr = Object.assign([], this.figuresArray)
      arr.map(function (item, index) {
        if (item.chartPie != undefined) {
          delete item.chartPie
        }
      })
      window.localStorage.setItem('dashBoardId', this.dashBoardId)
      window.localStorage.setItem('itemLayout', JSON.stringify(this.layout))
      window.localStorage.setItem(
        'itemFigures',
        JSON.stringify(arr)
      )
      router.push({
        path: '/home/add-single-chart',
        query: { id: this.dashBoardId }
      })
    },
    // 获取单图数据
    getSingleChartData () {
      let requestArr = []
      let resCount = 0
      let obj = {}
      for (var i = 0; i < this.figuresArray.length; i++) {
        requestArr[i] = getSingleChartDashBoard(this.figuresArray[i].id)
        requestArr[i].then(res => {
          resCount += 1
          if (res.data.code === '200') {
            obj[res.data.result.figureId] = res.data.result
            if (resCount === this.figuresArray.length) {
              this.loading = false
              this.chartObject = obj
              this.$nextTick(() => {
                this.readyDiv()
              })
            }
          } else {
            _g.toastMsg('error', res.data.error)
          }
        }).catch((err) => {
        })
      }
    },
    // 更新单图position
    saveDashBoardAction (type) {
      let newFiguresArray = []
      for (let j = 0; j < this.figuresArray.length; j++) {
        for (let i = 0; i < this.layout.length; i++) {
          if (this.layout[i].i === this.figuresArray[j].id) {
            this.figuresArray[j].showType = this.layout[i].showType
          }
        }
      }
      for (let it of this.figuresArray) {
        newFiguresArray.push({
          id: it.id,
          name: it.name,
          position: it.position,
          type: it.type,
          showType: it.showType,
        })
      }
      updateDashBoard(this.dashBoardId, newFiguresArray).then(res => {
        if (res.data.code === 0) {
          if (type === 1) {
            _g.toastMsg('success', '保存成功')
          }
        } else {
          _g.toastMsg('error', res.data.des)
        }
      })
    },
    // 循环加载图表
    readyDiv () {
      for (var j = 0; j < this.figuresArray.length; j++) {
        let position = []
        if (this.figuresArray[j].position.length !== 0) {
          let obj = this.figuresArray[j].position
          if (typeof obj == 'object' && obj.constructor === Array) {
            position = this.figuresArray[j].position
          } else {
            position = JSON.parse(this.figuresArray[j].position)
          }
        } else {
          position = [0, 0, 6, 10]
        }
        this.figuresArray[j].position = JSON.stringify(position)
        if (this.figuresArray[j].showType !== '') {
          if (this.figuresArray[j].showType === 'pieChart') {
            this.defalutResizedEvent(this.figuresArray[j].id, position[2], position[3], 'pieChart', j)
            this.chartObject[this.figuresArray[j].id].idName = "pieChart" + this.figuresArray[j].id
          } else if (this.figuresArray[j].showType === 'lineChart') {
            this.defalutResizedEvent(this.figuresArray[j].id, position[2], position[3], 'lineChart')
            this.chartObject[this.figuresArray[j].id].idName = "lineChart" + this.figuresArray[j].id
          } else if (this.figuresArray[j].showType === 'barGraph') {

            this.defalutResizedEvent(this.figuresArray[j].id, position[2], position[3], 'barGraph')
            this.chartObject[this.figuresArray[j].id].idName = "barGraph" + this.figuresArray[j].id
          } else if (this.figuresArray[j].showType === 'singleMetric') {
            this.defalutResizedEvent(this.figuresArray[j].id, position[2], position[3], 'singleMetric')
            this.chartObject[this.figuresArray[j].id].idName = "singleMetric" + this.figuresArray[j].id
          } else if (this.figuresArray[j].showType === 'table') {
            //计算表格总条数，每页显示数据，当前页
            let tableObj = this.chartObject[this.figuresArray[j].id]
            let total = Math.ceil(tableObj.tableData.tableData.length / 10)
            tableObj.tableData.total = total
            let showTableObj = this.getArrCont(0, 10, tableObj.tableData.tableData)
            tableObj.tableData.showTableObj = showTableObj
            this.chartObject[this.figuresArray[j].id].idName = "table" + this.figuresArray[j].id
            this.defalutResizedEvent(this.figuresArray[j].id, position[2], position[3], 'table')
          }
        } else if (this.figuresArray[j].showType === '') {
          if (this.chartObject[this.figuresArray[j].id].defaultShow === 'pieChart') {
            this.defalutResizedEvent(this.figuresArray[j].id, position[2], position[3], 'pieChart')
            this.chartObject[this.figuresArray[j].id].idName = "pieChart" + this.figuresArray[j].id

          } else if (this.chartObject[this.figuresArray[j].id].defaultShow === 'lineChart') {
            this.defalutResizedEvent(this.figuresArray[j].id, position[2], position[3], 'lineChart')
            this.chartObject[this.figuresArray[j].id].idName = "lineChart" + this.figuresArray[j].id
          } else if (this.chartObject[this.figuresArray[j].id].defaultShow === 'barGraph') {
            this.defalutResizedEvent(this.figuresArray[j].id, position[2], position[3], 'barGraph')
            this.chartObject[this.figuresArray[j].id].idName = "barGraph" + this.figuresArray[j].id

          } else if (this.chartObject[this.figuresArray[j].id].defaultShow === 'singleMetric') {
            this.defalutResizedEvent(this.figuresArray[j].id, position[2], position[3], 'singleMetric')
            this.chartObject[this.figuresArray[j].id].idName = "singleMetric" + this.figuresArray[j].id
          } else if (this.chartObject[this.figuresArray[j].id].defaultShow === 'table') {
            //计算表格总条数，每页显示数据，当前页
            let tableObj = this.chartObject[this.figuresArray[j].id]
            let total = Math.ceil(tableObj.tableData.tableData.length / 10)
            tableObj.tableData.total = total
            let showTableObj = this.getArrCont(0, 10, tableObj.tableData.tableData)
            tableObj.tableData.showTableObj = showTableObj
            this.chartObject[this.figuresArray[j].id].idName = "table" + this.figuresArray[j].id
            this.defalutResizedEvent(this.figuresArray[j].id, position[2], position[3], 'table')
          }
        }
      }
    },
    // 获取指定开始到结束下标的，数组内容
    getArrCont (start, end, arr) {
      let newarr = []
      arr.map(function (item, index) {
        if (index >= start && index < end) {
          newarr.push(item)
        }
      })
      return newarr
    },
    // 布局组件的生命周期  参数newLayout=> 布局的数据 每个布局数据
    layoutCreatedEvent (newLayout) {

    },
    layoutBeforeMountEvent (newLayout) {

    },
    layoutMountedEvent (newLayout) {

    },
    layoutReadyEvent (newLayout) {

    },
    layoutUpdatedEvent (newLayout) {
      for (var i = 0; i < newLayout.length; i++) {
        for (var j = 0; j < this.figuresArray.length; j++) {
          if (newLayout[i].i == this.figuresArray[j].id) {
            let array = []
            array = [newLayout[i].x, newLayout[i].y, newLayout[i].w, newLayout[i].h]
            this.figuresArray[j].position = JSON.stringify(array)
          }
        }
      }
      this.saveDashBoardAction()
    },
    searchLoad () {
      this.page = 1
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
    },
    handleCurrentChange (page) {
      this.page = page
      this.loading = true
      // this.loadTagList()
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res => {
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr = result.map((item) => {
            return item.perms
          })
          arrObj.map(it => {
            if (newarr.indexOf(it) !== -1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err => {
        this.$message.error(err)
      })
    }
  },
  created () {
    // 获取看板列表数据
    this.getListData('1')
  },
  mounted () {
    this.getButtonsList()
  },
}
</script>

<style scoped>
.nojian {
  cursor: none;
  color: #e2e3e3;
}
.pagetion {
  padding-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.pagetion_2 {
  color: #333;
  font-size: 16px;
}
.pagetion_1 {
  font-size: 23px;

  cursor: pointer;
}
.itemBoxshadow {
  -moz-box-shadow: 0px 5px 10px 5px rgba(217, 217, 217, 0.5);
  -webkit-box-shadow: 0px 5px 10px 5px rgba(217, 217, 217, 0.5);
  box-shadow: 0px 5px 10px 5px rgba(217, 217, 217, 0.5);
}

.fixIcone {
  display: none;
  position: absolute;
  bottom: 5px;
  right: 0;
  font-size: 16px;
  width: 25px;
  height: 20px;
  line-height: 25px;
}
.fixIcone img {
  width: 15px;
  height: auto;
}
.item-contentTest:hover {
  -moz-box-shadow: 0px 5px 10px 5px rgba(217, 217, 217, 0.5);
  -webkit-box-shadow: 0px 5px 10px 5px rgba(217, 217, 217, 0.5);
  box-shadow: 0px 5px 10px 5px rgba(217, 217, 217, 0.5);
}
.item-contentTest:hover .fixIcone {
  display: block;
}
.item-contentTest:hover .button-content {
  display: block;
}
.button-content {
  display: none;
}
.allBig_content {
  /*border: 1px solid;*/
}
.allBig_content > div {
  width: 50%;
  float: left;
}
.allBig_content > div > div {
  border: 1px solid #e2e3e3;
  margin: 10px;
  border-radius: 5px;
}
.allBig_title2 {
  display: flex;
  justify-content: left;
  align-items: center;
}
.allBig_title2 > img {
  margin-right: 5px;
}
.allBig_title2 span {
  font-size: 15px;
  padding-left: 5px;
}
.allBig_title1 {
  cursor: pointer;
  display: flex;
  justify-content: left;
  align-items: center;
}
.allBigDialog {
  z-index: 2000;
  position: fixed;
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: #fff;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.allBig_title {
  border-bottom: 1px solid #999999;
  display: flex;
  padding: 10px 30px;
  justify-content: space-between;
  align-items: center;
}
.allBig_title img {
  width: 25px;
}
.chart-title {
  text-align: left;
  padding-left: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 80px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.button-content > i {
  margin-left: 6px;
}
.vue-grid-layout > div {
  overflow: hidden;
  display: flex !important;
  justify-content: left;
  align-content: center;
}

.ant-pagination.mini .ant-pagination-options-quick-jumper input {
  width: 20px !important;
}
.chart-content1 {
  margin: 0 auto;
  padding-top: 0;
  display: flex;
  justify-content: center;
}
.table-div {
  width: 100%;
  overflow: auto;
  height: 100%;
  background-color: #fff;
}
.singleNum {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.singleNum_2 {
  font-weight: bold;
  font-size: 40px;
  color: #1980ff;
}
.board_blank {
  cursor: pointer;
  width: 300px;
  height: 300px;
  display: flex;
  margin: 0 25px;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #fff;
}
.board_blank i {
  color: #1980ff;
  font-size: 25px;
}
.board-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.board-title div {
  cursor: pointer;
  display: flex;
  padding: 0px 20px;
  justify-content: left;
  align-items: center;
}
.board-title div span {
  padding-left: 5px;
}
.board-content {
  background-color: #fff;
  margin: 0 25px;
}
.el-menu-item .menu-btn {
  display: none;
  float: right;
}
.el-menu-item:hover .menu-btn {
  display: block;
}
.cellDialog {
  text-align: left;
}
.getIt {
  color: #ff5500 !important;
}
.green {
  color: #05b324;
}
.red {
  color: #ff2b2b;
}
.cancelCreate {
  float: right;
  margin-right: 10px;
  color: #ff7373;
  cursor: pointer;
}
.el-menu-vertical-demo {
  position: relative;
}
.group-search {
  height: 93px;
  background: #fff;
}

.el-radio-group {
  margin-top: -13px;
}
.text-align-left {
  text-align: left;
}
.text-align-right {
  text-align: right;
}
.table-title {
  text-align: left;
}
.el-input--prefix .el-input__inner {
  padding-left: 40px !important;
}
.group-manage {
  overflow-x: hidden;
}
.el-icon-circle-plus-outline {
  cursor: pointer;
}
.push-page {
  color: #1980ff;
  cursor: pointer;
}
</style>
